import Vue from 'vue'
import VueRouter from 'vue-router'
import config from'@/config.js';
let app_name = config.name || 'new_app';
//load default modules (pages/blocks) configs
let node_modules_path = "../";
if(app_name!="ks_app"){
   node_modules_path = "../../";
}

Vue.use(VueRouter);

let routes = [];
//load default pages routes
let pages_req=[]
if(app_name!="ks_app"){
  pages_req=require('./pages/context.js');
  pages_req.default.forEach(p=>{routes.push(p);});
}
//load app pages routes
pages_req=require('@/pages/context.js');
pages_req.default.forEach(p=>{routes.push(p);});

let blocks = [];
//load default blocks routes
let blocks_req = [];
if(app_name!="ks_app"){
  blocks_req=require('./blocks/context.js');
  blocks_req.default.forEach(p=>{blocks.push(p);});
}
//load app blocks routes
blocks_req=require('@/blocks/context.js');
blocks_req.default.forEach(p=>{blocks.push(p);});

let module_req = {};
let modules = [];
let module_blocks=[];
let module_pages=[];

module_req = require.context('./modules', true, /index\.js$/i);
module_req.keys().map(key => {
  let name = key.match(/\w+/)[0];
  let index = module_req(key);
  index.name = name;
  modules.push(index);
  if(name!="ks_app"){
    if(app_name=="ks_app"){
      require(`../${name}/src/load.js`);
      module_blocks=require(`../${name}/src/blocks/context.js`);
      module_pages=require(`../${name}/src/pages/context.js`);
    }else{
      require(`../../${name}/src/load.js`);
      module_blocks=require(`../../${name}/src/blocks/context.js`);
      module_pages=require(`../../${name}/src/pages/context.js`);
    }
    module_blocks.default.forEach(b=>{blocks.push(b);}); 
    module_pages.default.forEach(p=>{routes.push(p);});
  }
});
//load app modules (pages/blocks) configs
module_req = require.context('@/modules', true, /index\.js$/i);
module_req.keys().map(key => {
  let name = key.match(/\w+/)[0];
  let index = module_req(key);
  index.name = name;
  modules.push(index);
  if(name!="ks_app"){
    if(app_name=="ks_app"){
      require(`../${name}/src/load.js`);
      module_blocks=require(`../${name}/src/blocks/context.js`);
      module_pages=require(`../${name}/src/pages/context.js`);
    }else{
      require(`../../${name}/src/load.js`);
      module_blocks=require(`../../${name}/src/blocks/context.js`);
      module_pages=require(`../../${name}/src/pages/context.js`);      
    }
    module_blocks.default.forEach(b=>{blocks.push(b);}); 
    module_pages.default.forEach(p=>{routes.push(p);});
  }
});

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});
router.afterEach((to)=>{
  let active_blocks = [];
  let aPath = to.path.split("/");
  blocks.forEach(
    (block)=>{
      if(block.paths.length > 0 ){
        for (let i = 0; i < block.paths.length; i++) {
          let bPath = block.paths[i].split("/");
          let pathMatch = true;
          if(aPath.length==bPath.length){
            for(let l = 0; l < aPath.length; l++){
              if( !(aPath[l]==bPath[l] || bPath[l]=="*") ) {
                pathMatch = false;
                break;
              }
            }
          }else{
            pathMatch = false;
          }
          if(pathMatch){
            if(!block.exclude_paths){active_blocks.push(block);}
            break;
          }else{
            if(i == block.paths.length){
              if(block.exclude_paths){active_blocks.push(block);}
            }
          }
        }
      }else{
        if(block.exclude_paths){active_blocks.push(block);}
      }
    }
  );
  router.app.set_active_blocks(active_blocks);
  app.showPreloader = false;
});

router.beforeEach(async (to, from, next) => {
  let mw = {};
  let mwName =  "";
  let mwPackage = "";
  let mwFile ="";
  app.showPreloader = true;

  //validate record of dataprovider has change
  if(typeof app.activePage !== 'undefined' && app.activePage.beforeClose !== null){
    try{
      let res = await app.activePage.beforeClose();
      if(!res) return false;
    }catch(err){
      console.log(err);
      return false;
    }
  }

  if(typeof app.activePage !== 'undefined' && app.activePage.confirmRecordChanges !== null){
    try{
      let res = await app.dataproviders[app.activePage.confirmRecordChanges].confirmRecordChanges();
      if(!res) return false;
    }catch(err){
      console.log(err);
      return false;
    }
  }

  if (to.name == 'http401' || to.name == 'http403' || to.name == 'http404' || !to?.meta?.middlewares || to?.meta?.middlewares.length == 0){
    next();
    return;
  }

  to.meta.middlewares.forEach(async(middleware)=>{

    if(typeof middleware ==="string"){
      mwName=middleware;
      mwPackage=middleware.split('/')[0];
      mwFile=middleware.split('/')[1];
      if(mwPackage==app_name){//load local
        mw=require(`@/middlewares/${mwFile}/index.js`);
      }else{//load node_modules
        if(app_name=="ks_app"){
          mw=require(`../${mwPackage}/src/middlewares/${mwFile}/index.js`);
        }else{
          mw=require(`../../${mwPackage}/src/middlewares/${mwFile}/index.js`);
        }
      }
      try{
        await mw.default();
        next();
        return;
      }catch(err){
        next(err);
        return;
      } 
    }

    if(typeof middleware ==="object"){
      let mwName =  Object.keys(middleware)[0];
      let mwPackage = mwName.split('/')[0];
      let mwFile = mwName.split('/')[1];
      if(mwPackage==app_name){//load local
        mw=require(`@/middlewares/${mwFile}/index.js`);
      }else{//load node_modules
        if(app_name=="ks_app"){
          mw=require(`../${mwPackage}/src/middlewares/${mwFile}/index.js`);
        }else{
          mw=require(`../../${mwPackage}/src/middlewares/${mwFile}/index.js`);
        }  
      }
      try{
        await mw.default(...middleware[mwName]);
        next();
      }catch(err){
        next(err);
      } 
    }
    
  })

})

export default router